module.exports = __webpack_public_path__ + "img/deafinition_logo_pic.6b553a17.png";